// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"180":"App","214":"views-error","475":"views","957":"views-app"}[chunkId] || chunkId) + "." + {"180":"287546bb","214":"04429948","475":"d1fd0907","527":"2bfb112e","583":"04229497","738":"10b41285","887":"bbe256b5","957":"402f0b9c","983":"2c4c61dc"}[chunkId] + ".chunk.js";
};